import { DateTime } from 'luxon';
import { FC } from 'react';
import { GlobalFreeze } from '../../types/freeze.types';
import styles from './GlobalFreezeBanner.module.css';

const GlobalFreezeBanner: FC<GlobalFreeze> = ({ endDate }) => (
  <div className={styles.banner} data-testid="global-freeze-banner">
    <span className={styles.bold}>Publish Pending -&nbsp;</span>
    <span>{`Estimated completion ${DateTime.fromISO(endDate).setZone('local').toFormat('f ZZZZ')}`}</span>
  </div>
);

export default GlobalFreezeBanner;
